export default __webpack_public_path__ + "static/media/plus_ic.3dd8d2f3.svg";